const isServer = typeof window === 'undefined';
export const env = {
  service_url: isServer ? process.env.NEXT_PUBLIC_LOCAL_SERVICE_URL : process.env.NEXT_PUBLIC_SERVICE_URL
}
